<div *ngIf="formType === 'coverpath'">
  MassMutual will automatically deduct payment every {{ frequency }} from your financial institution when a premium is
  due.
</div>

<div *ngIf="formType === 'haven'">
  Haven Life will automatically deduct payment every {{ frequency }} from your financial institution when a premium is
  due. Yeah, we're serious about this whole "making life less hard" thing.
</div>

<div *ngIf="formType === 'mmdirect'">
  MassMutual will automatically deduct payment every {{ frequency }} from your financial institution when a premium is
  due.
</div>
